import { Component } from 'react';
import { connect } from 'react-redux';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import DurationPicker from 'MeetingsLib/components/schedule/duration/DurationPicker';
import SkeletonTimePicker from 'MeetingsLib/components/schedule/time/SkeletonTimePicker';
import TimePickerV2 from '../schedule/time/TimePickerV2';
import StepButtonsFooter from 'MeetingsLib/components/page/StepButtonsFooter';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class TimeOptionsSection extends Component {
  constructor(...args) {
    super(...args);
    this.handleGoToPreviousStep = () => {
      const {
        goToPreviousStep
      } = this.props;
      goToPreviousStep();
    };
    this.getBorderRadiusProps = () => {
      const {
        compact
      } = this.props;
      if (compact) {
        return {};
      }
      return {
        borderStartStartRadius: '0',
        borderEndStartRadius: '0'
      };
    };
    this.renderTimePicker = () => {
      const {
        branding,
        compact,
        isFetchingPublicAvailability,
        profile,
        TimePickerMarker
      } = this.props;
      if (isFetchingPublicAvailability) {
        return /*#__PURE__*/_jsx(SkeletonTimePicker, {});
      }
      return /*#__PURE__*/_jsx(TimePickerV2, {
        branding: branding,
        compact: compact,
        profile: profile,
        TimePickerMarker: TimePickerMarker
      });
    };
    this.renderStepButtonsFooter = () => {
      const {
        branding,
        compact
      } = this.props;
      if (!compact) {
        return null;
      }
      return /*#__PURE__*/_jsx(StepButtonsFooter, {
        branding: branding,
        compact: compact,
        goToPreviousStep: compact ? this.handleGoToPreviousStep : undefined
      });
    };
  }
  render() {
    const {
      compact
    } = this.props;
    return /*#__PURE__*/_jsxs(CardWrapper, Object.assign({
      blockSize: "100%"
    }, this.getBorderRadiusProps(), {
      children: [/*#__PURE__*/_jsx(CardSection, {
        flush: true,
        compact: compact,
        paddingBlock: "0",
        paddingBlockEnd: compact ? '1000' : '0',
        minBlockSize: "0",
        children: /*#__PURE__*/_jsxs(TFlex, {
          flexDirection: "column",
          marginBlockEnd: "0",
          maxBlockSize: "100%",
          overflow: "hidden",
          inlineSize: "100%",
          children: [/*#__PURE__*/_jsx(View, {
            display: "inline-block",
            inlineSize: "100%",
            children: /*#__PURE__*/_jsx(DurationPicker, {})
          }), this.renderTimePicker()]
        })
      }), this.renderStepButtonsFooter()]
    }));
  }
}
export default connect(() => ({}), FormActions)(TimeOptionsSection);